import { Card, Dropdown, MenuProps, Row, Space } from "antd";
import { useState } from "react";
import { DownOutlined, UpOutlined } from '@ant-design/icons';

import { UserInfoManager } from "../utils/UserInfoManager";
import { StyleUtils } from "../utils/Style";
import { GlobalUtil } from "../utils/GlobalText";
import events from "../utils/events";
import { AppEvent } from "../data/events";
import Api from "../utils/Api";

const LanguageView: React.FC = () => {
    const [isOpen, setOpen] = useState(false)
    const itemValues = [
        { name: "English", url: "/assets/english.png" },
        { name: "简体中文", url: "/assets/chinese.png" },
    ]
    const values = [
        "en_US", "zh_CN"
    ]
    let index = (UserInfoManager.language && UserInfoManager.language.startsWith("zh") ? 1 : 0) ?? 0
    const items: MenuProps['items'] = itemValues.map((v, idx) => {
        return {
            key: idx,
            label: <div key={idx} style={{ display: "flex", alignItems: "center", color: StyleUtils.theme().fontColor_1 }} onClick={async () => {
                setOpen(false)
                if (values[idx] === UserInfoManager.language) {
                    return
                }
                try {
                    UserInfoManager.language = values[idx]
                    let res = await Api.setCurEnvInfo(UserInfoManager.currentAccount, UserInfoManager.currency, values[idx])
                    GlobalUtil.changeLanguage(values[idx])
                    // if (res.code === ApiCode.SUCCESS) {
                    events.emit(AppEvent.REFRES, { "language": true });
                    events.emit(AppEvent.ChangeStyle, "")
                    // }
                } catch (error) {
                    console.log(error);
                }

            }}>
                {/* <img style={{ width: 20, height: 20, margin: "4px 4px 0 0" }} src={v.url} alt={values[index]} />  */}
                {v.name}
            </div>,
        }
    })
    return <Dropdown
         open={isOpen}
         dropdownRender={() => (
           <Card
             bodyStyle={{ padding: 0, display: 'flex', flexDirection: 'column' }}
             style={{
               borderColor: StyleUtils.theme().boardBg,
               background: StyleUtils.theme().boardBg,
               padding: 0
             }}
             hoverable
           >
             {itemValues.map((item, idx) => (
               <div
                 key={idx}
                 style={{
                   display: "flex",
                   alignItems: "center",
                   padding: "8px 24px",
                   background: index === idx ? StyleUtils.theme().mainItemColor : StyleUtils.theme().mainColor,
                   color: StyleUtils.theme().fontColor_1,
                   marginBottom: idx !== itemValues.length - 1 ? ".25rem" : "0",
                   cursor: "pointer"
                 }}
                 onClick={async () => {
                   setOpen(false);
                   if (values[idx] === UserInfoManager.language) return;
                   try {
                     UserInfoManager.language = values[idx];
                     await Api.setCurEnvInfo(UserInfoManager.currentAccount, UserInfoManager.currency, values[idx]);
                     GlobalUtil.changeLanguage(values[idx]);
                     events.emit(AppEvent.REFRES, { language: true });
                     events.emit(AppEvent.ChangeStyle, "");
                   } catch (error) {
                     console.error(error);
                   }
                 }}
               >
                 {item.name}
               </div>
             ))}
           </Card>
         )}
         trigger={['click']}
         getPopupContainer={() => document.getElementById('language')!}
         onOpenChange={setOpen}
       >
         <Row className="flex-grow">
           <div
             onClick={(e) => e.preventDefault()}
             style={{
               background: StyleUtils.theme().mainColor2,
               borderRadius: StyleUtils.getWidth(5),
               textDecoration: "none",
               cursor: "pointer"
             }}
             className="user"
           >
             <Space
               className="user-lang"
               style={{
                 color: StyleUtils.theme().fontColor_1,
                 fontSize: StyleUtils.getFont(13),
                 display: "flex",
                 alignItems: "center"
               }}
             >
               {itemValues[index].name}
               {isOpen ? <UpOutlined /> : <DownOutlined />}
             </Space>
           </div>
         </Row>
       </Dropdown>
}

export default LanguageView